export enum EmploymentType {
  Permanent = "Permanent",
  Temporary = "Temporary",
}
